import { useEffect, useState } from 'react';
import { Header } from '../../components/Header/Header';
import { SearchBar } from '../../components/SearchBar/SearchBar';
import { SearchResult } from '../../components/SearchResult/SearchResult';
import './Home.css';
import { useRooms } from '../../hooks/useRooms';

export const Home = (props) => {
  const { cdn } = props;
  const { rooms } = useRooms();

  const [query, setQuery] = useState('');
  const [result, setResult] = useState([]);

  const handleSearch = (searchQuery) => {
    setQuery(searchQuery);

    if (searchQuery) {
      const filteredResults = rooms.filter(
        (item) => item.label === 'SERVICE MÉDICAL' || item.label.includes(searchQuery.toUpperCase())
      );

      if (filteredResults.length > 1) {
        setResult(filteredResults);
      } else {
        setResult(rooms);
      }
    } else {
      setResult(rooms);
    }
  };

  useEffect(() => {
    if (query === '') {
      setResult(rooms);
    }
  }, [rooms, query]);

  return (
    <div className="page home-page">
      <Header cdn={cdn} btn="info" />
      <div className="home-page__content">
        <div className="home-page__content__search">
          <SearchBar cdn={cdn} onSearch={handleSearch} />
        </div>
        <SearchResult result={result} />
      </div>
    </div>
  );
};
